import React, { useEffect, useState } from 'react';
import { isAuthenticated} from "../../store/action/auth";
import { useDispatch, useSelector } from "react-redux";
import { getWallet } from "../../store/action/billing";
import numeral from 'numeral';
import ReactLoading from 'react-loading';

const Sidebar = (props) => {
  const { user, token } = isAuthenticated();
  const path = props.location.pathname;
  const dispatch = useDispatch();
  const [ testData, setTestData ] = useState(localStorage.getItem('biteship_test_data')||'notActive') 
  const wallet = useSelector(s => s.wallet);

  useEffect(() => {
    dispatch(getWallet(token));
  }, []);

  const onChangeTestData = () => {
    localStorage.setItem('biteship_test_data', testData === 'active' ? 'notActive' : 'active');
    setTestData( testData === 'active' ? 'notActive' : 'active')
    window.location.reload()
  }
  
  if (!user) {
    return null
  }
  
  return (
    <nav className="col-md-2 d-none d-md-block sidebar mt-4">
      <div className='sidebar-sticky'>
        <ul className="nav flex-column">
          <li className="nav-item">
            <a
              href="/overview"
              className={`nav-link ${path === '/overview' ? 'active':'' }`}>
              <i className="fas fa-home mr-3"></i>
              <span>Beranda</span>
            </a>
          </li>
          {
            user.role !== 'owner' ? '' :
                <li className={"nav-item"}>
                  <a href="/address" className={`nav-link ${path === '/address' ? 'active':'' }`}>
                    <i className="fas fa-map mr-3"></i>
                    <span>Alamat</span>
                  </a>
                </li>
          }
          {
            user.type !== 'warehouse' ? '' :
                <li className={"nav-item"}>
                  <a href="/catalog" className={`nav-link ${path === '/catalog' ? 'active':'' }`}>
                    <i className="fas fa-box mr-3"></i>
                    <span>Katalog</span>
                  </a>
                </li>
          }
          {
            user.type !== 'warehouse' ? '' :
                <li className={"nav-item"}>
                  <a href="/form" className={`nav-link ${path === '/form' ? 'active':'' }`}>
                    <i style={{marginLeft:3}} className="fas fa-file-alt mr-3"></i>
                    <span>Form</span>
                  </a>
                </li>
          }
          {
            user.role !== 'owner' ? '' :
            <li className={"nav-item"}>
              <a href="/integrations" className={`nav-link ${path.includes('/integrations')  || path === '/api-production-form'? 'active':'' }`}>
                <i className="fas fa-key mr-3"></i>
                <span>Integrasi</span>
              </a>
            </li>
          }
          <li className={"nav-item"}>
            <a onClick={() => onChangeTestData()} className={`nav-link d-flex`}>
              <div className="custom-control custom-switch">
                  <input
                      type="checkbox"
                      className="custom-control-input "
                      checked={testData === 'active'}
                      onChange={() => console.log("Switched Mode")} 
                    />
                  <label className="custom-control-label"></label>
              </div>
              <span>Mode testing</span>
            </a>
          </li>
        </ul>
        <hr className="mb-0"/>
        <ul className="nav flex-column">
          <li className={"nav-item"}>
            <a href="/setting" className={`nav-link ${path === '/setting' ? 'active':'' }`}>
              <i className="fas fa-cog mr-3"></i>
              <span>Pengaturan</span>
            </a>
          </li>
          <li className={"nav-item"}>
            <a href="/tickets" className={`nav-link ${path === '/tickets' ? 'active':'' }`}>
              <i className="fas fa-ticket-alt mr-3"></i>
              <span>Support Tiket</span>
            </a>
          </li> 
          {
            wallet.type === 'postpaid' || wallet.loading ? '' :
            <div className={"nav-item"}>
              <a href="/billing" className={`nav-link d-flex ${
                path === '/billing'  || 
                path === '/postpaid-registration' ||
                path === '/billing/payout-form' ? 'active':'' }`}>
                <div>
                  <i className="fas fa-wallet mr-3"></i>
                </div>
                <div>
                  <div>
                    <span>Bite Points</span>
                    <br/>
                    {
                      wallet.loading ?
                          <div className="text-info d-flex">
                            <ReactLoading
                                type={'bubbles'}
                                color={'#459BD8'}
                                height={24}
                                width={24}
                            />
                            <b>loading...</b>
                          </div> :
                          <b className="text-info">{numeral(wallet.balance).format("0,0")} Pts</b>
                    }
                  </div>
                </div>
              </a>
            </div>
          }
          {
            user.role !== 'owner' ? '' :
                <li className={"nav-item"}>
                  <a href="/analytics" className={`nav-link ${path === '/analytics' ? 'active':'' }`}>
                    <i className="fas fa-chart-line mr-3"></i>
                    <span>Analytics </span>
                  </a>
                </li>
          }
          {
            wallet.type === 'postpaid' || wallet.loading ?
                <li className={"nav-item"}>
                  <a href="/billing" className={`nav-link ${path === '/billing' ? 'active':'' }`}>
                    <i className="fas fa-receipt mr-3"></i>
                    <span>Transaksi</span>
                  </a>
                </li> : null
          }
           
        </ul>
        <ul className="nav flex-column mt-4">
          <li className="nav-item">
            <a
              href="https://api.whatsapp.com/send?phone=+628111317800"
              className={`nav-link`}>
              <i className="fas fa-headset mr-3"></i>
              <span>Bantuan</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  )
};


export default Sidebar;
